export default "__VITE_ASSET__e5c9aa4a__"